import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Component that scrolls to the top of the page on route changes.
 * This ensures that when navigating to a new page, the user starts at the top
 * instead of wherever they were scrolled to on the previous page.
 */
const RouteRestoration = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        // Immediate scroll to top without smooth behavior to prevent "fighting" with browser restoration
        window.scrollTo(0, 0);
    }, [pathname]);

    return null;
};

export default RouteRestoration;
